var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { MOUNT_POINT_OSX } from '@lucidlink/sdk';
import { InlineForm, TextInputField, translate } from '@lucidlink/uicore';
import { useFormRoot } from '@lucidlink/uicore/form-builder';
import { PII_MASK_CLASS } from '#constants';
import { DEPENDENCY_KEYS, useDependency } from '#context';
const MACOS_MOUNT_POINT_ID = 'macos-mount-point';
export const MacosMountPoint = ({ data, filespaceId, workspaceId, }) => {
    _react_refresh_temp_2();
    const { handleToasts } = useDependency(DEPENDENCY_KEYS.UseFilespaceSettingsToasts)({
        filespaceId,
        workspaceId,
        settingName: MOUNT_POINT_OSX,
    });
    const { formData: { macOSMountPoint: formMacOSMountPoint = '' }, } = useFormRoot();
    const { mutation: { isSuccess, mutate: setGlobalSettings }, } = useDependency(DEPENDENCY_KEYS.UseSetGlobalSettings)({
        filespaceId,
        workspaceId,
        setting: MOUNT_POINT_OSX,
    }, {
        onSuccess: () => {
            handleToasts();
        },
    });
    const { default: defaultValue, isDefault, value } = data;
    const autoGenerated = translate('Auto generated');
    const { mutation: { mutate: unsetGlobalSetting }, } = useDependency(DEPENDENCY_KEYS.UseUnsetGlobalSettings)({
        filespaceId,
        workspaceId,
        setting: MOUNT_POINT_OSX,
    }, {
        onSuccess: () => {
            handleToasts({ isReset: true });
        },
    });
    const unsetMacOSMountPoint = useCallback(() => {
        unsetGlobalSetting([MOUNT_POINT_OSX]);
    }, [unsetGlobalSetting]);
    const onMountPointReset = useDependency(DEPENDENCY_KEYS.UseOnMountPointReset)();
    const resetMountPoint = useCallback(() => {
        if (onMountPointReset) {
            onMountPointReset({
                defaultMountPoint: defaultValue || autoGenerated,
                mountPoint: MOUNT_POINT_OSX,
                reset: unsetMacOSMountPoint,
            });
        }
        else {
            unsetMacOSMountPoint();
        }
    }, [autoGenerated, defaultValue, onMountPointReset, unsetMacOSMountPoint]);
    const resetToDefault = isDefault
        ? undefined
        : {
            label: translate('Reset to default'),
            onReset: resetMountPoint,
            tooltip: translate(`The default value is: {{value}}`, {
                value: defaultValue || autoGenerated,
            }),
        };
    const labelDefault = isDefault ? translate('Default') : undefined;
    const labelTooltip = useMemo(() => [
        translate('macOS only. Specify the path where the filespace will be mounted.'),
        translate('Accepted options:'),
        translate('Valid absolute path (e.g. "/Volumes/workspace/filespace"'),
    ], []);
    const setMacOSMountPoint = useCallback(() => setGlobalSettings([
        { fullName: MOUNT_POINT_OSX, value: formMacOSMountPoint },
    ]), [formMacOSMountPoint, setGlobalSettings]);
    return (_jsx(InlineForm, { cancelAriaLabel: translate('Cancel'), "data-testid": MACOS_MOUNT_POINT_ID, formElement: (labelProps) => (_jsx(TextInputField, { ...labelProps, autoFocus: true, "data-testid": MACOS_MOUNT_POINT_ID, id: MACOS_MOUNT_POINT_ID, initialValue: value, name: "macOSMountPoint" })), inputId: MACOS_MOUNT_POINT_ID, isSaveAllowed: value !== formMacOSMountPoint, isSuccess: isSuccess, label: translate('macOS mount point'), labelDefault: labelDefault, labelTooltip: labelTooltip, onSave: setMacOSMountPoint, resetToDefault: resetToDefault, saveAriaLabel: translate('Save'), tooltipPosition: "right", value: value || autoGenerated, valueClassName: PII_MASK_CLASS, width: "sm" }));
};
_react_refresh_temp_1 = MacosMountPoint;
$RefreshReg$(_react_refresh_temp_1, "MacosMountPoint");
_react_refresh_temp_2(MacosMountPoint, "ezV4z/n4Ty1MgwpKM+FxZHRmsSk=", false, () => [useDependency, useFormRoot, useDependency, useDependency, useDependency]);
